// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".consent-reminder{background-color:#e8f3fc;padding:16px 5px 18px 12px;border-radius:10px}", ""]);
// Exports
module.exports = exports;
